var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167",
    transform: "translate(-356 -74)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Button",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(356 74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4166",
    "data-name": "Group 4166",
    transform: "translate(-1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell-svgrepo-com",
    transform: "translate(371 87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-1450.042-67a3,3,0,0,1-1.6-.49,2.993,2.993,0,0,1-1.09-1.271,1,1,0,0,1,.5-1.324,1,1,0,0,1,1.324.5,1.006,1.006,0,0,0,.363.424,1,1,0,0,0,.534.163,1,1,0,0,0,.538-.148,1,1,0,0,0,.375-.414,1,1,0,0,1,1.337-.46,1,1,0,0,1,.461,1.337,3,3,0,0,1-1.124,1.24A3,3,0,0,1-1450-67Zm6.043-6h2a2,2,0,0,1-2,2Zm-1,2v-2h1a1.99,1.99,0,0,0-.55-1.377A4.333,4.333,0,0,1-1446-77.243h2c0,.4.292.849.9,1.489A3.99,3.99,0,0,1-1442-73h-2v2Zm-10,0v-2h10v2Zm-1,0a2,2,0,0,1-2-2h3v2Zm-2-2a3.99,3.99,0,0,1,1.1-2.755c.608-.64.9-1.087.9-1.489h2a4.332,4.332,0,0,1-1.45,2.867A1.99,1.99,0,0,0-1456-73Zm12-4.243V-80a4,4,0,0,0-4-4,4,4,0,0,0-4,4h-2a6,6,0,0,1,5-5.917V-86a1,1,0,0,1,1-1,1,1,0,0,1,1,1v.083A6,6,0,0,1-1444-80v2.757Zm-10,0V-80h2v2.757Z",
    transform: "translate(1462 89)",
    fill: "#ff3535"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.af64818764b3b5b0285f95d9cdcdceaa.svg";
export { ForwardRef as ReactComponent };